import React, { useState, useEffect } from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useSelector, useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PostedJobViewAction } from "./../../Redux/action/PostedJobViewAction";
import { VendorJobUpdate } from '../../Redux/action/VendorJobDetailsAction';
import { FaEye } from 'react-icons/fa';
import { TbExternalLink } from 'react-icons/tb';
import { MdOutlineBackup } from 'react-icons/md';
import Pagination from '../Common/Pagination/Pagination';
import { SpinLoader } from './ImportCandidates';
import { toast } from 'react-toastify';
import { CiEdit } from 'react-icons/ci';
import { fetchDesignationDetails } from '../../Redux/action/MasterSkillAction';
import Select from "react-select";
const HoldJob = (props) => {
    const { activeTab, setActiveTab } = props;
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [loadingJobId, setLoadingJobId] = useState(null);
    const [selectedDesignation, setSelectedDesignation] = useState([]);
    const [designationSendapi, setDesignationSendAPI] = useState([]);
    const AllDesignationList = useSelector(
        (state) => state?.MasterTableDetails?.designation?.content
    );
    const handleDesignationChange = (selectedOptions) => {
        setSelectedDesignation(selectedOptions);
        const selectedValues = selectedOptions.map((option) => option.value);
        setDesignationSendAPI(selectedValues);
    };
    const userInfo = useSelector((state) => state?.JobView?.result?.jobs);
    const totalPages = useSelector((state) => state?.JobView?.result?.totalPages);

    const updateLoading = useSelector((state) => state?.VendorJobUpdate?.loading);
    // const updateLoading = useSelector((state) => state?.VendorJobUpdate?.);

    let dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const vId = queryParams?.get('vendorId')
    const { userResult } = useSelector((state) => state.Auth);
    const id = vId ? vId : userResult?.vendorid;
    const posted = props.posted

    const content = {
        id,
        posted,
        pageNumber,
        search,
        designationSendapi
    }

    useEffect(() => {
        dispatch(PostedJobViewAction(content));
    }, [pageNumber, selectedDesignation]);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);
    const newData = userInfo;
    const navigate = useNavigate();

    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });

    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);
        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);
        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }


    // const handlePostJob = (jobId) => {
    //     setLoadingJobId(jobId);
    //     const content = {
    //         jobId,
    //         pageNumber,
    //         jobsPostedStatus: "POSTED"
    //     }

    //     const allContent = {
    //         jobs: content,
    //     }

    //     dispatch(VendorJobUpdate(allContent, () => {
    //         setLoadingJobId(null);
    //         toast.success('posted successfully')
    //     }));

    //     setTimeout(() => {
    //         setActiveTab('posted')
    //     }, 1000);
    // }

    const handlePageChange = (page) => {
        setPageNumber(page);
        // You can also fetch data for the new page here or update your component state accordingly
    };

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        dispatch(fetchDesignationDetails());
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const designationOptions = AllDesignationList?.map((item) => ({
        value: item?.designation,
        label: item?.designation,
    }));


    return (
        <div>

            <div style={{ padding: "10px 20px", borderBottom: "1px solid #d2d7d7" }}>
                <div className={width > 768 ? "form-outline" : ""}>
                    {/* <input
                        className="form-control"
                        type="search"
                        placeholder="Search by Designation"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    ></input> */}
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            options={designationOptions}
                            isMulti
                            onChange={handleDesignationChange}
                            placeholder="Select Designation"
                            value={selectedDesignation}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#286a94" : "#ccc",
                                    boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                                    "&:hover": { borderColor: "#286a94" },
                                    minHeight: "25px",
                                    fontSize: "11px", // affects input text
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: "10px",   // dropdown options font size
                                    padding: "6px 8px",
                                    backgroundColor: state.isSelected
                                        ? "#286a94"
                                        : state.isFocused
                                            ? "#e6f2fa"
                                            : "white",
                                    color: state.isSelected ? "white" : "#333",
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e6f2fa",
                                    borderRadius: "8px",
                                    padding: "0px 0px",
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // selected tag label font size
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // for single select case
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: "#777",
                                    fontSize: "11px",
                                }),
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="">
                <div className="card-header common_table_header">
                    Drafted Jobs
                </div>
                <div className="card-body table-responsive">
                    <table className="table-data" style={{ fontSize: '14px', overflowX: 'auto', minWidth: location.pathname.includes('admin') ? '65rem' : "" }}>
                        <thead>
                            <tr>
                                <th className='fw_500' scope="col">Job Id</th>
                                <th className='fw_500' scope="col">Designation</th>
                                {/* <th className='fw_500' scope="col">Key Skills</th> */}
                                <th className='fw_500' scope="col">Experience</th>
                                {/* <th className='fw_500' scope="col">Status</th> */}
                                <th className='fw_500' scope="col">Created Date</th>
                                <th className='fw_500' scope="col">Job Details</th>
                                {/* {
                                    !location.pathname.includes('/admin/posted_jobs') &&
                                    <th className='fw_500' scope="col">Edit Job</th>} */}
                                {
                                    (!location.pathname.includes('/admin/posted_jobs') &&
                                        !location.pathname.includes('/admin/job/vendor_jobs')) && (
                                        <th className='fw_500' scope="col">Post</th>)
                                }
                                {/* <th scope="col">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems && currentItems.map((item, i) => {
                                return (
                                    <>
                                        <tr key={i}>
                                            <td>{item.jobUuid}</td>
                                            <td>{item.jobTitle}</td>
                                            {/* <td>{item.requiredSkills}</td> */}
                                           <td>
                                            {item.minimumExperience?.includes(
                                              "0"
                                            )
                                              ? `Fresher - ${item.maximumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} years`
                                              : `${item.minimumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} - ${item.maximumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} years`}
                                          </td>
                                            {/* <td>
                                                <div style={{ minWidth: "55%" }} className={`w-75 m-auto mb-0 ${(item.jobsPostedStatus === 'EXPIRED' || item.jobsPostedStatus === 'DELETED') ? 'red_status' : (item.jobsPostedStatus === "POSTED") ? 'green_status' : "yellow_status"}`}>
                                                    {item.jobsPostedStatus === 'EXPIRED' ? 'Expired' : item.jobsPostedStatus === 'POSTED' ? 'Posted' : item.jobsPostedStatus === "ONHOLD" ? "On Hold" : 'Deleted'}
                                                </div>
                                            </td> */}
                                            <td>{item.createdDate}</td>
                                            <td><Link to={location.pathname.includes('/admin/posted_jobs')
                                                ? `/admin/view/job-details?jobId=${item.jobId}`
                                                : location.pathname.includes('/admin/job/vendor_jobs')
                                                    ? `/admin/job/viewJob?jobId=${item.jobId}` : `/job-details/${item.jobId}`}>
                                                <TbExternalLink size={24} color='#286a94' />
                                            </Link></td>
                                            {/* <td>
                                            <div variant="contained" onClick={()=>handlePostJob(item.jobId)}>
                                                {!updateLoading ? <MdOutlineBackup size={24} color='#286a94' className='pointer' /> : <SpinLoader/> }
                                            </div>
                                        </td> */}
                                            {/* {
                                                !location.pathname.includes('/admin/posted_jobs') &&
                                                <td><Link to={`/edit_job/${item.jobId}`}><CiEdit size={24} color='#286a94' className='pointer' /></Link></td>
                                            } */}
                                            {
                                                (!location.pathname.includes('/admin/posted_jobs') &&
                                                    !location.pathname.includes('/admin/job/vendor_jobs')) && (
                                                    <td>
                                                        <div variant="contained" onClick={() => navigate(`/post_job/${item.jobId}`)}>
                                                            {loadingJobId === item.jobId ? <SpinLoader /> : <MdOutlineBackup size={24} color='#286a94' className='pointer' />}
                                                        </div>

                                                    </td>)
                                            }
                                            {/* <td style={{ color: 'red', cursor: "pointer" }}><DeleteOutlineIcon /></td> */}
                                        </tr>
                                    </>
                                )
                            })}
                        </tbody>
                    </table>
                    {currentItems?.length === 0 && (
                        <div className="text-center mt-5">
                            <h5>No Data Found</h5>
                        </div>
                    )}
                </div>
            </div>
            {userInfo?.length >= 1 ? (
                <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
            ) : (
                ""
            )}
        </div>
    )
}

export default HoldJob